import styled from 'styled-components';

export const ContainerCenter = styled.div`
  height: 100vh;
  width: 100%;
  background-color: #eff1f5;
`;

export const TopDiv = styled.div`
  display: flex;
  width: 100%;
`;

export const MainContainer = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  min-height: 600px;
  min-width: 750px;
`;

export const ContainerCenterInside = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  align-items: center;
`;

export const Header = styled.div`
  position: relative;
  width: 96%;
  display: flex;
  align-items: center;
  height: 2.68rem;
  margin-top: 2.5rem;
  user-select: none;
  margin-bottom: 1.5rem;
  z-index: 1;
`;

export const Togle = styled.div`
  width: 19.22rem;
  height: 2.68rem;
  display: flex;

  background: #ffffff;
  border: 0.07rem solid #d4d6da;
  box-sizing: border-box;
  border-radius: 0.4rem;
  align-items: center;
  position: relative;
`;

export const ToggleTest = styled.div`
  position: absolute;
  width: 49%;
  height: 85%;
  border-radius: 0.4rem;
  background-color: #40e5a0;
  left: ${({ toggleState }) => (toggleState === false ? '1%' : '50%')};
  pointer-events: none;
  z-index: 1;
  transition: 0.2s ease-out;
`;

export const ToggleEmAndamento = styled.div`
  width: 49%;
  height: 85%;
  margin-left: 1%;
  border-radius: 0.4rem;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: 'Sora';
  font-style: normal;
  font-weight: 600;
  font-size: 0.76rem;
  line-height: 0.95rem;
  color: #585e66;

  //animation block
  z-index: 2;
  user-select: none;
  cursor: pointer;
`;

export const ToggleTodasTarefas = styled.div`
  width: 49%;
  height: 85%;
  margin-right: 1%;
  border-radius: 0.4rem;
  display: flex;
  justify-content: center;
  align-items: center;

  font-family: 'Sora';
  font-style: normal;
  font-weight: 600;
  font-size: 0.76rem;
  line-height: 0.95rem;
  color: #585e66;
  //animation block
  z-index: 2;
  user-select: none;
  cursor: pointer;
`;

export const InputDiv = styled.div`
  width: 20.9rem;
  display: flex;
  align-items: center;
  height: 2.68rem;
  /* margin-left: 2rem; */
`;

export const FilterActivesText = styled.span`
  font-family: 'Sora';
  font-style: normal;
  font-weight: 600;
  font-size: 0.8rem;
  line-height: 1rem;
  color: #118052;
  margin-left: 0.7rem;
`;

export const FilterActivesData = styled.span`
  font-family: 'Sora';
  font-style: normal;
  font-weight: 400;
  font-size: 0.8rem;
  line-height: 1rem;
  color: #118052;
  margin-left: 0.1rem;
  white-space: nowrap;
`;

export const FilterActivesClose = styled.div`
  margin-left: 0.5rem;
  margin-right: 0.7rem;
  width: 0.35rem;
  height: 0.35rem;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  path {
    stroke: #5bb18e;
  }
`;

export const FlowButton = styled.div`
  display:flex;
  position: absolute;
  right: 0;
 
  height: 100%;
`;
